import styled, { DefaultTheme } from 'styled-components';

type Variant = keyof DefaultTheme['typograph'];

const Container = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
`;

const Title = styled.h1`
  padding: 0px 8px;
  font-size: 28px;
  font-weight: 500;
  text-align: center;
  margin-top: 14px;
  margin-bottom: 28px;
`;

const SubTitle = styled.h2<{ vMargin?: string }>`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin-top: ${props => (props.vMargin ? props.vMargin : 20)}px;
  margin-bottom: ${props => (props.vMargin ? props.vMargin : 20)}px;
`;

const Text = styled.p<{ variant: Variant; vMargin?: string }>`
  ${props => props.theme.typograph[props.variant]};
  margin: ${props => (props.vMargin ? props.vMargin : 16)}px 0px;
`;

const ExpirationDateText = styled.p<{ variant?: Variant }>`
  ${props => props.theme.typograph[props.variant || 'smallBold']};
  margin-top: 16px;
`;

const SplitMessage = styled.hr`
  border: 1px solid ${props => props.theme.color.neutral60};
  margin: 30px 0px 30px 0px;
`;

const ImageTitle = styled.div`
  margin-bottom: 5px;
  align-items: 'center';
`;

const Icon = styled.img`
  width: 60px;
  height: 60px;
`;

export {
  Container,
  Title,
  SubTitle,
  Text,
  ExpirationDateText,
  SplitMessage,
  ImageTitle,
  Icon,
};
